export function hasActiveCustomerOwner(customerId, customers, users) {
  const customer = customers.find((item) => item.id === customerId);
  if (!customer) return false;
  const owner = users.find((item) => item.id === customer.ownerId);
  return Boolean(owner && owner.active !== false);
}

export function customerOwnerOptions(customers, users) {
  return customers.map((customer) => ({
    value: customer.id,
    label: `${customer.name}${hasActiveCustomerOwner(customer.id, customers, users) ? "" : " (inactive owner)"}`,
  }));
}
